import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import ScrollToTop from "react-scroll-to-top"

import Header from "./header"
import Footer from "./footer"

const Layout = ({ children }) => {

  const menu = ['Oferta','Mapa Stacji',"Regulamin",'Cennik','FAQ','Aktualności','Punkty VITAY']

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        siteDesc={data.site.siteMetadata?.description || `Description`}
        menu={menu}
      />
      <main>{children}</main>
      <Footer />
      <ScrollToTop smooth color="white" className="scrollToTop" />
    </>
  )
}

export default Layout
